/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Negotiate_Current_OfferInputs */

const en_salary_negotiate_current_offer = /** @type {(inputs: Salary_Negotiate_Current_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current Offer`)
};

const de_salary_negotiate_current_offer = /** @type {(inputs: Salary_Negotiate_Current_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuelles Angebot`)
};

const fr_salary_negotiate_current_offer = /** @type {(inputs: Salary_Negotiate_Current_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offre actuelle`)
};

const es_salary_negotiate_current_offer = /** @type {(inputs: Salary_Negotiate_Current_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferta actual`)
};

const it_salary_negotiate_current_offer = /** @type {(inputs: Salary_Negotiate_Current_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offerta attuale`)
};

const nl_salary_negotiate_current_offer = /** @type {(inputs: Salary_Negotiate_Current_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huidig aanbod`)
};

const pl_salary_negotiate_current_offer = /** @type {(inputs: Salary_Negotiate_Current_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obecna oferta`)
};

const fi_salary_negotiate_current_offer = /** @type {(inputs: Salary_Negotiate_Current_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nykyinen tarjous`)
};

const da_salary_negotiate_current_offer = /** @type {(inputs: Salary_Negotiate_Current_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuværende tilbud`)
};

const sv_salary_negotiate_current_offer = /** @type {(inputs: Salary_Negotiate_Current_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuvarande erbjudande`)
};

/**
* | output |
* | --- |
* | "Current Offer" |
*
* @param {Salary_Negotiate_Current_OfferInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_negotiate_current_offer = /** @type {((inputs?: Salary_Negotiate_Current_OfferInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Negotiate_Current_OfferInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_negotiate_current_offer(inputs)
	if (locale === "fr") return fr_salary_negotiate_current_offer(inputs)
	if (locale === "es") return es_salary_negotiate_current_offer(inputs)
	if (locale === "it") return it_salary_negotiate_current_offer(inputs)
	if (locale === "nl") return nl_salary_negotiate_current_offer(inputs)
	if (locale === "pl") return pl_salary_negotiate_current_offer(inputs)
	if (locale === "fi") return fi_salary_negotiate_current_offer(inputs)
	if (locale === "da") return da_salary_negotiate_current_offer(inputs)
	if (locale === "sv") return sv_salary_negotiate_current_offer(inputs)
	return en_salary_negotiate_current_offer(inputs)
});